import {map} from 'rxjs/operators';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import ExtendedChildCheckin, {type ChildCheckinExtendedResponse} from './models/extended-child-checkin';

export const signInObservable = (
    childId: string,
    pickupTime?: string,
    pickupRelationId?: string,
    goHomeWithChildId?: string,
    statementIds?: string[],
) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkins`, {
        pickupTime,
        pickupRelationId,
        goHomeWithChildId,
        statementIds,
    });
};

export const fetchCheckinAndRelations = (childId: string) => {
    return RESTClient.getAuthenticatedObservable('v2/childcheckins/extended', {
        childId,
    }).pipe(
        map((response: ChildCheckinExtendedResponse) => {
            return ExtendedChildCheckin.fromAPI(response);
        }),
    );
};
